'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _Sizes = require('./Sizes');

var _Sizes2 = _interopRequireDefault(_Sizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Column = function (_Component) {
  _inherits(Column, _Component);

  function Column() {
    _classCallCheck(this, Column);

    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }

  _createClass(Column, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          wide = _props.wide,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['wide', 'className']);

      var cx = (0, _classnames2.default)(wide ? _Sizes2.default[wide - 1] + ' wide' : null, 'column', className);

      return _react2.default.createElement(_Box2.default, _extends({
        className: cx
      }, rest));
    }
  }]);

  return Column;
}(_react.Component);

Column.displayName = 'Column';

Column.propTypes = {
  wide: _propTypes2.default.number
};

exports.default = Column;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbHVtbi5qcyJdLCJuYW1lcyI6WyJDb2x1bW4iLCJwcm9wcyIsIndpZGUiLCJjbGFzc05hbWUiLCJyZXN0IiwiY3giLCJkaXNwbGF5TmFtZSIsInByb3BUeXBlcyIsIm51bWJlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7O0lBRU1BLE07Ozs7Ozs7Ozs7OzZCQUNLO0FBQUEsbUJBQzRCLEtBQUtDLEtBRGpDO0FBQUEsVUFDREMsSUFEQyxVQUNEQSxJQURDO0FBQUEsVUFDS0MsU0FETCxVQUNLQSxTQURMO0FBQUEsVUFDbUJDLElBRG5COztBQUVQLFVBQUlDLEtBQUssMEJBQ1BILE9BQVUsZ0JBQU1BLE9BQU8sQ0FBYixDQUFWLGFBQW1DLElBRDVCLEVBRVAsUUFGTyxFQUdQQyxTQUhPLENBQVQ7O0FBTUEsYUFDRTtBQUNFLG1CQUFXRTtBQURiLFNBRU1ELElBRk4sRUFERjtBQU1EOzs7Ozs7QUFHSEosT0FBT00sV0FBUCxHQUFxQixRQUFyQjs7QUFFQU4sT0FBT08sU0FBUCxHQUFtQjtBQUNqQkwsUUFBTSxvQkFBVU07QUFEQyxDQUFuQjs7a0JBSWVSLE0iLCJmaWxlIjoiQ29sdW1uLmpzIiwic291cmNlUm9vdCI6IkQ6XFxQcm9qZWN0c1xccmVhY3QtdG9jYXNcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/Column.js
// module id = 564
// module chunks = 0